<template>
  <div id="context" class="panel">
    <p class="panel-heading">
      {{ contextTitle }}
    </p>
    <div class="panel-block">
      <EventList v-if="selectedType === eventType" />
      <ParkingContext
        v-if="selectedType === parkingType"
        :entityId="selectedItem.properties.entityId"
        :highlightDate="selectedDate"
        :parkingChartData="parkingChartData"
        :chartMaxYAxis="selectedItem.properties.totalSpots"
      />
      <Traffic
        v-if="selectedType === trafficType"
        :selectedItem="selectedItem"
      />
      <Vr v-if="selectedType === vrType" />
      <Antea
        v-if="selectedType === anteaType"
        :highlightDate="selectedDate"
        :MeasurementData="MeasurementData"
      />
      <Tracker v-if="selectedType === trackerType" />
      <MetricWire
        v-if="selectedType === surveyType"
        :selectedItem="selectedItem"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import constants from "../../constants";

import MetricWire from "./MetricWire";
import EventList from "./EventList";
import ParkingContext from "./ParkingContext";
import Traffic from "./Traffic";
import Vr from "./VR";
import Antea from "./Antea";
import Tracker from "./Tracker";

export default {
  name: "Context",
  components: {
    EventList,
    ParkingContext,
    Traffic,
    Vr,
    Antea,
    Tracker,
    MetricWire
  },
  props: {
    selectedType: String,
    selectedItem: Object
  },
  watch: {
    selectedItem: function(item) {
      if (item.layer.id === this.parkingType) {
        // eslint-disable-next-line
        console.log("Fetch Parking Data: ", item.properties.entityId);
        this.$store.dispatch("fetchParkingContext", {
          entityId: item.properties.entityId,
          nameParking: item.properties.name,
          startDate: this.$store.getters.dataFilterStartDate,
          endDate: this.$store.getters.dataFilterEndDate,
          location: this.$store.getters.navigationActiveTab.name.toLowerCase()
        });
      }
    }
  },
  computed: {
    selectedDate() {
      let currentDate = this.$store.getters.dataCurrentDate;
      if (currentDate) {
        return moment(currentDate);
      }
      return undefined;
    },
    contextTitle() {
      let title = constants.CONTEXT_TITLE_MAPPING[this.selectedType];
      if (title) return title;
      else return "Oops";
    },
    eventType() {
      return constants.MAP_LAYER_EVENT_ID;
    },
    parkingType() {
      return constants.MAP_LAYER_PARKING_ID;
    },
    trafficType() {
      return constants.MAP_LAYER_TRAFFIC_ID;
    },
    anteaType() {
      return constants.MAP_LAYER_ANTEA_ID;
    },
    vrType() {
      return constants.MAP_LAYER_VR_ID;
    },
    trackerType() {
      return constants.MAP_LAYER_TRACKERS_ID;
    },
    surveyType() {
      return constants.MAP_LAYER_SURVEY_ID;
    },
    parkingChartData() {
      return this.$store.getters.dataParkingDatasets[
        this.selectedItem.properties.entityId
      ];
    },
    MeasurementData() {
      //Reformat data into chartdata
      // console.log('getter Antea data', this.$store.getters.dataAntea)
      return this.$store.getters.dataAntea;
    }
  }
};
</script>

<style scoped>
.no-padding {
  padding: 0;
}
</style>
